export const SET_CURRENT_ADDRESS = 'app/WithAddress/SET_CURRENT_ADDRESS';
export const WITHADDRESS = 'WithAddress';
